import { gql } from "@apollo/client";

export const GET_REPORT_OPERATORS = gql`
    query GetReportOperators($warehouseId: Long!) {
        getReportOperatorsForWms(warehouseId: $warehouseId) {
            id
            name
        }
    }
`;

export interface ReportOperatorType {
    id: string;
    name: string;
}

export interface GetReportOperatorsResponse {
    getReportOperatorsForWms: ReportOperatorType[];
}
